import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({
  eyebrow,
  title,
  subtitle,
  align = "left",
  tone = "light",
  className = "",
}) => {
  const isDark = tone === "dark";
  const alignment = align === "center" ? "items-center text-center mx-auto" : "items-start text-left";
  return (
    <Reveal className={`flex flex-col ${alignment} ${align === "center" ? "max-w-2xl" : "max-w-3xl"} ${className}`}>
      {eyebrow && (
        <span
          className="az-eyebrow mb-3"
          style={isDark ? { color: "var(--svc-accent, #C99A3D)" } : undefined}
        >
          <span className="inline-block h-px w-6" style={{ background: "currentColor" }} />
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-heading text-3xl sm:text-4xl lg:text-[2.85rem] font-semibold leading-[1.1] tracking-[-0.01em] ${
          isDark ? "text-[var(--svc-invert,#F1F4F8)]" : "text-[var(--svc-ink,#193D6D)]"
        }`}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          className={`mt-4 text-lg leading-relaxed ${
            isDark ? "text-[rgba(244,246,249,0.78)]" : "text-[var(--svc-muted,#586576)]"
          }`}
        >
          {subtitle}
        </p>
      )}
    </Reveal>
  );
};
